import _ from 'lodash';
import {
  getAnalytics,
  setAnalyticsCollectionEnabled,
  isSupported,
} from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { useStorage } from '../../hooks/use-storage';
import { isDevEnv } from '../manager/host-manager';

// Novo:
// https://firebase.google.com/docs/analytics/get-started?platform=web&hl=pt-br
// Mais: https://developers.google.com/analytics/devguides/collection/ga4/reference/events#sign_up

let analytics;

function analyticsSetup() {
  const firebaseConfig = {
    apiKey: 'AIzaSyAC-A-LqmTL42t0qJzxXAzu2vhwgjOAD_Y',
    authDomain: 'menur-338815.firebaseapp.com',
    projectId: 'menur-338815',
    storageBucket: 'menur-338815.appspot.com',
    messagingSenderId: '95435637551',
    appId: '1:95435637551:web:0ccf94a2c7aa39e95a17da',
    measurementId: 'G-6ZJS09MPX8',
  };

  isSupported().then((supported) => {
    if (supported) {
      const app = initializeApp(firebaseConfig);
      analytics = getAnalytics(app);

      setAnalyticsCollectionEnabled(analytics, !isDevEnv);
    }
  });
}

function useAnalytics() {
  const storage = useStorage(true);

  function setDimensions() {
    const dimensions = {};

    if (!_.isEmpty(storage?.menuSlug))
      dimensions.dimension1 = storage?.menuSlug;
    if (!_.isEmpty(storage?.spot?.name))
      dimensions.dimension2 = storage?.spot?.name;
    if (!_.isEmpty(storage?.origin)) dimensions.dimension3 = storage?.origin;
    if (!_.isEmpty(storage?.loggedIn?.id))
      dimensions.dimension4 = storage?.loggedIn?.id;

    // if (!_.isEmpty(dimensions)) ReactGA.set(dimensions);
  }

  async function analyticsPageView(name) {
    setDimensions();

    if (isDevEnv) console.log(`analytics pageview: ${name}`);
    // ReactGA.pageview(name);
  }

  async function analyticsHollowEvent(action) {
    analyticsEvent('hollow', action);
  }

  async function analyticsHelpEvent(action) {
    analyticsEvent('help', action);
  }

  async function analyticsFeatureUseEvent(action) {
    analyticsEvent('feature', action);
  }

  async function analyticsAlertEvent(action) {
    analyticsEvent('alert', action);
  }

  async function analyticsEvent(category, action) {
    if (!analytics) return;

    setDimensions();

    if (isDevEnv) console.log(`analytics event: ${category}, ${action}`);
    // ReactGA.event({ category, action });
  }

  function analyticsException(error, fatal = false) {
    setDimensions();

    const description = _.isObject(error) ? JSON.stringify(error) : error;

    if (isDevEnv)
      console.log(
        `analytics exception: fatal:${fatal ? 'true' : 'false'} ${description}`
      );

    // ReactGA.exception({
    //   description,
    //   fatal,
    // });
  }

  return {
    analyticsPageView,
    analyticsHollowEvent,
    analyticsHelpEvent,
    analyticsFeatureUseEvent,
    analyticsAlertEvent,
    analyticsException,
  };
}

export { useAnalytics, analyticsSetup };
